export function buildScoringComponentMetadata(components = []) {
  const orderedComponents = [...components].sort(
    (left, right) =>
      (left.display_order ?? 10000) - (right.display_order ?? 10000) ||
      String(left.level || "").localeCompare(String(right.level || "")) ||
      String(left.code || "").localeCompare(String(right.code || ""))
  );
  const byCode = Object.fromEntries(orderedComponents.map((component) => [component.code, component]));
  const hierarchyLabel = (componentOrCode) => {
    const component = typeof componentOrCode === "string" ? byCode[componentOrCode] : componentOrCode;
    if (!component) return "";
    const labels = [];
    let current = component;
    const seen = new Set();
    while (current && !seen.has(current.code)) {
      labels.unshift(current.name || current.code);
      seen.add(current.code);
      current = current.parent ? byCode[current.parent] : null;
    }
    return labels.join(" > ");
  };
  const byLevel = orderedComponents.reduce((acc, component) => {
    const level = component.level || "metric";
    acc[level] = [...(acc[level] || []), component];
    return acc;
  }, {});
  const selectOptions = orderedComponents.map((component) => ({
    value: component.code,
    label: hierarchyLabel(component),
    level: component.level,
    parent: component.parent,
  }));
  return { byCode, orderedComponents, byLevel, hierarchyLabel, selectOptions };
}

export function defaultRelationshipComponents(components = []) {
  const pillar = components.find((component) => component.level === "pillar");
  const overall = components.find((component) => component.code === "overall");
  return {
    x: pillar?.code || components[0]?.code || "",
    y: overall?.code || components[1]?.code || components[0]?.code || "",
  };
}
